import React, { createContext, ReactNode } from 'react';
import AudioManager from '../services/AudioManager';

export const AudioContext = createContext<AudioManager | null>(null);

interface AudioProviderProps {
  children: ReactNode;
}

const audioManager = AudioManager.getInstance();

export const AudioProvider: React.FC<AudioProviderProps> = ({ children }) => {
  return (
    <AudioContext.Provider value={audioManager}>
      {children}
    </AudioContext.Provider>
  );
};
